import "./DateRange.css"
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import calender from "../../assets/img/icons/calendar-1322-svgrepo-com.svg";

interface DateRangeProps {
   startDate?: Date | null;
   endDate?: Date | null;
   setStartDate(date: Date, event: React.SyntheticEvent<any, Event>): void;
   setEndDate(date: Date, event: React.SyntheticEvent<any, Event>): void;

}
const DateRange: React.FC<DateRangeProps> = ({ startDate, endDate, setStartDate, setEndDate }) => {
   return (
      <div className='flex main-range-div align-items-center w-100 w-lg-auto'>

         <img src={calender} alt="calender" className="calender-img" />
         <ReactDatePicker selected={startDate}
            onChange={setStartDate}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            placeholderText='Start Date'
            className='date-range-1 bg-transparent border-0 ' />
         <span>
            -
         </span>

         <ReactDatePicker
            selected={endDate}
            onChange={setEndDate}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            placeholderText='End Date'
            className='date-range-2 bg-transparent border-0 ' />
      </div>
   );
};

export default DateRange;
